const STORAGE_KEY = 'FORCE_UPDATE_POST_TOAST_PENDING'

// 조용한 갱신(safe 경로)은 리로드로 문서가 통째로 바뀌므로, 리로드 직전에 여기 마킹해두고
// 재부팅된 페이지에서 한 번 소비해 사후 토스트를 띄운다. 토스트 표시는 앱이 주입한다.
// 저장소가 차단된 브라우저에서는 접근 자체가 SecurityError 로 실패할 수 있다 —
// 갱신·렌더링을 막지 않도록 조용히 토스트만 생략한다.
export const markPendingToast = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1')
  } catch {
    // 저장 불가 — 사후 토스트 생략
  }
}

export const showPendingToastIfAny = (showToast: (message: string) => void) => {
  try {
    if (!sessionStorage.getItem(STORAGE_KEY)) return
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    return
  }
  showToast('최신 버전으로 갱신되었습니다.')
}
